<div class="flex flex-col grow shrink-0 pb-2 pt-[22px] relative cursor-default">
  <button type="button" class="absolute right-[10px] top-[10px] flex flex-col items-center justify-center w-[20px] h-[20px]" mat-dialog-close>
    <mat-icon svgIcon="cross-icon" class="!w-full !h-auto max-w-[16px] max-h-[16px] text-[#90A2A5]"></mat-icon>
  </button>
  <div class="flex flex-col mt-[22px]">
    <div
      class="w-[62px] h-[62px] rounded-[50%] bg-[#ACBBBE]/20 flex flex-col items-center justify-center self-center">
      <mat-icon svgIcon="desktop-with-cursor" class="!w-full !h-auto max-w-[42px] max-h-[25px] text-[#ACBBBE]"></mat-icon>
    </div>
  </div>
  <div class="flex flex-col px-[15px]">
        <span class="text-[16px] font-medium self-center mt-[12px]">
         Desktop App Benefits
        </span>
    <ul
      class="flex flex-col list-marked list-marked-light-gray text-[#778F8F] text-[16px] mt-3 leading-[1.4] gap-y-[10px]">
      <li>
        One place for all wallet monitoring and risk checks.
      </li>
      <li>
        Pause or remove wallets from monitoring in one click.
      </li>
      <li>
        Team workspaces, roles, and permissions for business users.
      </li>
      <li>
        Real‑time balance and invoice downloads for compliance reports.
      </li>
    </ul>
    <hr class="border-[#022D35]/20 mt-[20px] mb-2">
    <div class="flex items-center justify-center w-full">

      <button
        [appCopyToClipboardCopied]="linkWebVersion() + '/register-corporate-account'"
        type="button"
        class="flex items-center justify-center w-full min-h-[56px] bg-[#C93535] disabled:bg-[#C93535]/60 rounded-[4px] text-white text-[16px] leading-[1.26px] font-medium
              hover:bg-[#C93535] focus:bg-[#C52525]">
        <mat-icon svgIcon="link-icon" class="!w-full !h-auto max-w-[22px] max-h-[22px] mr-[18px]"></mat-icon>
        Copy Desktop App Link
      </button>
    </div>
  </div>
</div>
